// import React, { useState } from 'react';
// import payment from './payment.png'
// const EventRegistrationForm = () => {
//   const [formData, setFormData] = useState({
//     name: '',
//     email: '',
//     mobile: '',
//     district: '320A',
//     club_name: '',
//     business_profession: ''
//   });
//   const [paymentProof, setPaymentProof] = useState(null);
//   const [loading, setLoading] = useState(false);
//   const [statusMessage, setStatusMessage] = useState({ type: '', text: '' });

//   const districts = ['320A', '320B', '320C', '320D', '320E', '320F', '320G', '320H'];

//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     setFormData((prev) => ({ ...prev, [name]: value }));
//   };

//   const handleFileChange = (e) => {
//     if (e.target.files && e.target.files[0]) {
//       setPaymentProof(e.target.files[0]);
//     }
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     if (!paymentProof) {
//       setStatusMessage({ type: 'error', text: 'Please upload the payment proof image.' });
//       return;
//     }

//     setLoading(true);
//     setStatusMessage({ type: '', text: '' });

//     const submissionData = new FormData();
//     Object.keys(formData).forEach((key) => {
//       submissionData.append(key, formData[key]);
//     });
//     submissionData.append('payment_proof', paymentProof);

//     try {
//       const response = await fetch('http://localhost:10005/signup/api/register-event', {
//         method: 'POST',
//         body: submissionData
//       });

//       const data = await response.json();

//       if (response.ok && data.success) {
//         setStatusMessage({
//           type: 'success',
//           text: 'Registration successful! Confirmation email has been sent.'
//         });
//         setFormData({
//           name: '',
//           email: '',
//           mobile: '',
//           district: '320A',
//           club_name: '',
//           business_profession: ''
//         });
//         setPaymentProof(null);
//         e.target.reset();
//       } else {
//         throw new Error(data.message || 'Registration failed');
//       }
//     } catch (err) {
//       setStatusMessage({ type: 'error', text: err.message });
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <div style={{ maxWidth: '600px', margin: '40px auto', padding: '24px', border: '1px solid #ddd', borderRadius: '8px', fontFamily: 'Arial, sans-serif' }}>
//       <h2 style={{ textAlign: 'center', color: '#1a1a1a', marginBottom: '20px' }}>
//         LBN MD 320- OPTIMIZE LIONISM ENGAGEMENT
//       </h2>

//       {statusMessage.text && (
//         <div style={{
//           padding: '12px',
//           marginBottom: '16px',
//           borderRadius: '4px',
//           backgroundColor: statusMessage.type === 'success' ? '#d4edda' : '#f8d7da',
//           color: statusMessage.type === 'success' ? '#155724' : '#721c24'
//         }}>
//           {statusMessage.text}
//         </div>
//       )}



//       {/* Registration Form */}
//       <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '14px' }}>
//         <div>
//           <label style={{ display: 'block', marginBottom: '4px', fontWeight: 'bold' }}>Name</label>
//           <input
//             type="text"
//             name="name"
//             required
//             value={formData.name}
//             onChange={handleInputChange}
//             style={{ width: '100%', padding: '8px', boxSizing: 'border-box' }}
//           />
//         </div>

//         <div>
//           <label style={{ display: 'block', marginBottom: '4px', fontWeight: 'bold' }}>Email</label>
//           <input
//             type="email"
//             name="email"
//             required
//             value={formData.email}
//             onChange={handleInputChange}
//             style={{ width: '100%', padding: '8px', boxSizing: 'border-box' }}
//           />
//         </div>

//         <div>
//           <label style={{ display: 'block', marginBottom: '4px', fontWeight: 'bold' }}>Mobile</label>
//           <input
//             type="tel"
//             name="mobile"
//             required
//             value={formData.mobile}
//             onChange={handleInputChange}
//             style={{ width: '100%', padding: '8px', boxSizing: 'border-box' }}
//           />
//         </div>

//         <div>
//           <label style={{ display: 'block', marginBottom: '4px', fontWeight: 'bold' }}>District</label>
//           <select
//             name="district"
//             value={formData.district}
//             onChange={handleInputChange}
//             style={{ width: '100%', padding: '8px', boxSizing: 'border-box' }}
//           >
//             {districts.map((d) => (
//               <option key={d} value={d}>{d}</option>
//             ))}
//           </select>
//         </div>

//         <div>
//           <label style={{ display: 'block', marginBottom: '4px', fontWeight: 'bold' }}>Club Name:</label>
//           <input
//             type="text"
//             name="club_name"
//             required
//             value={formData.club_name}
//             onChange={handleInputChange}
//             style={{ width: '100%', padding: '8px', boxSizing: 'border-box' }}
//           />
//         </div>

//         <div>
//           <label style={{ display: 'block', marginBottom: '4px', fontWeight: 'bold' }}>Business / Profession :</label>
//           <input
//             type="text"
//             name="business_profession"
//             required
//             value={formData.business_profession}
//             onChange={handleInputChange}
//             style={{ width: '100%', padding: '8px', boxSizing: 'border-box' }}
//           />
//         </div>
//               {/* QR Code Section */}
//       <div style={{ textAlign: 'center', marginBottom: '24px', background: '#000', padding: '16px', borderRadius: '8px', color: '#fff' }}>
//         <h4 style={{ margin: '0 0 10px 0' }}>Scan & Pay INR Rs.500</h4>
//         <img 
//           src={payment} 
//           alt="Payment QR Code" 
//           style={{ width: '220px', height: 'auto', borderRadius: '4px', display: 'block', margin: '0 auto' }} 
//         />
//         <p style={{ marginTop: '10px', fontSize: '13px', color: '#bbb' }}>INAPANURI PAVAN CHAKRAVARTHY</p>
//       </div>

//         <div>
//           <label style={{ display: 'block', marginBottom: '4px', fontWeight: 'bold' }}>Payment Proof (INR Rs.500) :</label>
//           <input
//             type="file"
//             name="payment_proof"
//             accept="image/*"
//             required
//             onChange={handleFileChange}
//             style={{ width: '100%', padding: '8px', boxSizing: 'border-box' }}
//           />
//         </div>

//         <button
//           type="submit"
//           disabled={loading}
//           style={{
//             padding: '12px',
//             backgroundColor: '#0056b3',
//             color: '#fff',
//             border: 'none',
//             borderRadius: '4px',
//             cursor: loading ? 'not-allowed' : 'pointer',
//             fontWeight: 'bold',
//             marginTop: '10px'
//           }}
//         >
//           {loading ? 'Submitting...' : 'Register Now'}
//         </button>
//       </form>
//     </div>
//   );
// };

// export default EventRegistrationForm;


import React, { useState } from 'react';
import payment from './payment.png';

const EventRegistrationForm = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    mobile: '',
    district: '320A',
    club_name: '',
    business_profession: ''
  });
  const [paymentProof, setPaymentProof] = useState(null);
  const [loading, setLoading] = useState(false);

  const districts = ['320A', '320B', '320C', '320D', '320E', '320F', '320G', '320H'];

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleFileChange = (e) => {
    if (e.target.files && e.target.files[0]) {
      setPaymentProof(e.target.files[0]);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!paymentProof) {
      alert('Please upload the payment proof image.');
      return;
    }

    setLoading(true);

    const submissionData = new FormData();
    Object.keys(formData).forEach((key) => {
      submissionData.append(key, formData[key]);
    });
    submissionData.append('payment_proof', paymentProof);

    try {
      const response = await fetch('https://api.lbnhyderabad.com/signup/api/register-event', {
        method: 'POST',
        body: submissionData
      });

      const data = await response.json();

      if (response.ok) {
        alert(data.message || 'Registration successful! Confirmation email has been sent.');
        setFormData({
          name: '',
          email: '',
          mobile: '',
          district: '320A',
          club_name: '',
          business_profession: ''
        });
        setPaymentProof(null);
        e.target.reset();
      } else {
        alert(data.message || 'Registration failed. Please try again.');
      }
    } catch (err) {
      alert(`Error: ${err.message || 'Something went wrong. Please check your connection.'}`);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ maxWidth: '600px', margin: '40px auto', padding: '24px', border: '1px solid #ddd', borderRadius: '8px', fontFamily: 'Arial, sans-serif' }}>
      <h2 style={{ textAlign: 'center', color: '#1a1a1a', marginBottom: '20px' }}>
        LBN MD 320- OPTIMIZE LIONISM ENGAGEMENT
      </h2>

  
      {/* Registration Form */}
      <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '14px' }}>
        <div>
          <label style={{ display: 'block', marginBottom: '4px', fontWeight: 'bold' }}>Name</label>
          <input
            type="text"
            name="name"
            required
            value={formData.name}
            onChange={handleInputChange}
            style={{ width: '100%', padding: '8px', boxSizing: 'border-box' }}
          />
        </div>

        <div>
          <label style={{ display: 'block', marginBottom: '4px', fontWeight: 'bold' }}>Email</label>
          <input
            type="email"
            name="email"
            required
            value={formData.email}
            onChange={handleInputChange}
            style={{ width: '100%', padding: '8px', boxSizing: 'border-box' }}
          />
        </div>

        <div>
          <label style={{ display: 'block', marginBottom: '4px', fontWeight: 'bold' }}>Mobile</label>
          <input
            type="tel"
            name="mobile"
            required
            value={formData.mobile}
            onChange={handleInputChange}
            style={{ width: '100%', padding: '8px', boxSizing: 'border-box' }}
          />
        </div>

        <div>
          <label style={{ display: 'block', marginBottom: '4px', fontWeight: 'bold' }}>District</label>
          <select
            name="district"
            value={formData.district}
            onChange={handleInputChange}
            style={{ width: '100%', padding: '8px', boxSizing: 'border-box' }}
          >
            {districts.map((d) => (
              <option key={d} value={d}>{d}</option>
            ))}
          </select>
        </div>

        <div>
          <label style={{ display: 'block', marginBottom: '4px', fontWeight: 'bold' }}>Club Name:</label>
          <input
            type="text"
            name="club_name"
            required
            value={formData.club_name}
            onChange={handleInputChange}
            style={{ width: '100%', padding: '8px', boxSizing: 'border-box' }}
          />
        </div>

        <div>
          <label style={{ display: 'block', marginBottom: '4px', fontWeight: 'bold' }}>Business / Profession :</label>
          <input
            type="text"
            name="business_profession"
            required
            value={formData.business_profession}
            onChange={handleInputChange}
            style={{ width: '100%', padding: '8px', boxSizing: 'border-box' }}
          />
        </div>
            {/* QR Code Section */}
      <div style={{ textAlign: 'center', marginBottom: '24px', background: '#000', padding: '16px', borderRadius: '8px', color: '#fff' }}>
        <h4 style={{ margin: '0 0 10px 0' }}>Scan & Pay INR Rs.500</h4>
        <img 
          src={payment} 
          alt="Payment QR Code" 
          style={{ width: '220px', height: 'auto', borderRadius: '4px', display: 'block', margin: '0 auto' }} 
        />
        <p style={{ marginTop: '10px', fontSize: '13px', color: '#bbb' }}>INAPANURI PAVAN CHAKRAVARTHY</p>
      </div>


        <div>
          <label style={{ display: 'block', marginBottom: '4px', fontWeight: 'bold' }}>Payment Proof (INR Rs.500) :</label>
          <input
            type="file"
            name="payment_proof"
            accept="image/*"
            required
            onChange={handleFileChange}
            style={{ width: '100%', padding: '8px', boxSizing: 'border-box' }}
          />
        </div>

        <button
          type="submit"
          disabled={loading}
          style={{
            padding: '12px',
            backgroundColor: '#0056b3',
            color: '#fff',
            border: 'none',
            borderRadius: '4px',
            cursor: loading ? 'not-allowed' : 'pointer',
            fontWeight: 'bold',
            marginTop: '10px'
          }}
        >
          {loading ? 'Submitting...' : 'Register Now'}
        </button>
      </form>
    </div>
  );
};

export default EventRegistrationForm;